<template>
  <div class="full_page">

    <h1>One Plant Combined Accounts</h1>

    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead>
      <th>Units Sold</th>
      <th>Gummies</th>
      <th>Sours</th>
      <th>Pre-Roll</th>
      <th>Sleep</th>
      <th>Wonder</th>
      <th>HARD 8th</th>
      <th>Noah's</th>
      <th>14 PK</th>
      <th>1g's</th>
      <th>Rice</th>
      <th>Plant</th>
      <th>Poppy's</th>
      <th>Samples</th>
      </thead>
      <tr>
        <td>{{customer_detail.total_qty_ordered}}</td>
        <td>{{customer_detail.total_qty_ordered_gummies}}</td>
        <td>{{customer_detail.total_qty_ordered_sour}}</td>
        <td>{{customer_detail.total_qty_ordered_preroll}}</td>
        <td>{{customer_detail.total_qty_ordered_sleep}}</td>
        <td>{{customer_detail.total_qty_ordered_wonder}}</td>
        <td>{{customer_detail.total_qty_ordered_hard8th}}</td>
        <td>{{customer_detail.total_qty_ordered_noahs}}</td>
        <td>{{customer_detail.total_qty_ordered_14pk}}</td>
        <td>{{customer_detail.total_qty_ordered_1gs}}</td>

        <td>{{customer_detail.total_qty_ordered_rice}}</td>
        <td>{{customer_detail.total_qty_ordered_plant}}</td>
        <td>{{customer_detail.total_qty_ordered_poppys}}</td>

        <td>{{customer_detail.total_samples}}</td>
      </tr>
    </table>

    <div class="graph_background">
      <line-chart ytitle="Sales $" prefix="$ " :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA','#000000']" :data=customer_detail.graph_data.amount></line-chart>
    </div>

    <div class="graph_background">
      <line-chart ytitle="Units" prefix="" :dataset="{borderWidth: 3}" :colors="['#4cd9ae', '#1500e8','#6c9900','#8d0291','#AA0000','#00AA00','#AA00AA','#000000']" :data=customer_detail.graph_data.count></line-chart>
    </div>

    <template v-if="customer_detail.order_details.length > 0">
      <table class="table table-striped table-bordered table-hover table-condensed">
        <thead>
        <tr class="description_small">
          <th>#</th>
          <th>Order Date</th>
          <th>Ship Date</th>
          <!--          <th>Days To Next Order</th>-->
          <!--          <th>Avg Qty To Next Order</th>-->
          <th>Total Units</th>
          <th>Gummies</th>
          <th>Sours</th>
          <th>Pre-Roll</th>
          <th>Sleep</th>
          <th>Wonder</th>
          <th>HARD 8th</th>
          <th>Noah's</th>
          <th>14 PK</th>
          <th>1g's</th>

          <th>Rice</th>
          <th>Plant</th>
          <th>Poppy's</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="order_detail in customer_detail.order_details" v-bind:key="order_detail.id">
          <td>{{order_detail.position}}</td>
          <td>{{order_detail.day}}</td>
          <td>{{order_detail.ship_date}}</td>
          <!--          <td>{{order_detail.days_to_next_order}}</td>-->
          <!--          <td>{{order_detail.average_sold_to_next_order}}</td>-->

          <template v-if="order_detail.qty_other === 0">
            <td>{{order_detail.qty_total}}</td>
          </template>
          <template v-else>
            <td class="text-color-red">{{order_detail.qty_total}}</td>
          </template>

          <td>{{order_detail.qty_gummies}}</td>
          <td>{{order_detail.qty_sour}}</td>
          <td>{{order_detail.qty_preroll}}</td>
          <td>{{order_detail.qty_sleep}}</td>
          <td>{{order_detail.qty_wonder}}</td>
          <td>{{order_detail.qty_hard8th}}</td>
          <td>{{order_detail.qty_noahs}}</td>
          <td>{{order_detail.qty_14pk}}</td>
          <td>{{order_detail.qty_1gs}}</td>

          <td>{{order_detail.qty_rice}}</td>
          <td>{{order_detail.qty_plant}}</td>
          <td>{{order_detail.qty_poppys}}</td>

        </tr>
        </tbody>
      </table>
    </template>

    <br>
    <br>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      customerData: {
        new_note: '',
        combined_shop: 1703,
      },
      showInfoButtons: false,
    }
  },
  computed: {
    ...mapGetters({
      customer_detail: 'admin/customer_detail',
    }),
  },
  mounted() {
    this.GetEazeDetail();
  },
  destroyed() {
    this.$store.dispatch('admin/emptyDetailPage');
  },
  methods: {
    // todo: This is a copy of combines EAZE but with code 1703 instead of 1213
    GetEazeDetail () {
      this.$store.dispatch('admin/getCustomerDetail', {'customer_id': 604225, 'is_noah': 0, 'combined_shop': 1703});
    },
  }
}

</script>

<style scoped>

.description_small {
  font-size: smaller;
}

.text-color-red {
  color:red;
}

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.graph_background {
  border-radius: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10pX;
  background: #FFF;
}

</style>

